import { animate, state, style, transition, trigger } from '@angular/animations';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserInfoService } from '../shared/services/user-info.service';

@Component({
	selector: 'app-cookie-consent',
	templateUrl: './cookie-consent.component.html',
	styleUrls: ['./cookie-consent.component.less'],
	animations: [
		trigger('fade',
			[
				state("desktop", style({ transform: "translateY(-80px)", opacity: 1 })),
				state("mobile", style({ transform: "translateY(100vh)", opacity: 1})),
				transition("void => desktop", animate('0.3s ease-out')),
				transition("desktop => void", animate('0.3s ease-out')),
				transition("void => mobile", animate('0.3s ease-out')),
				transition("mobile => void", animate('0.3s ease-out'))
			])
		]
})
export class CookieConsentComponent implements OnInit{
	
	show!: boolean;
	@Input() force: boolean = false;
	clicked: boolean = false;
	media: string = "desktop";

	constructor(
		private readonly _userInfoService: UserInfoService,
		private readonly _breakpointObserver: BreakpointObserver
	) {
		this.show = (_userInfoService.userInfo.cookiePolicyAccepted != false && _userInfoService.userInfo.cookiePolicyAccepted != true);
	}

	ngOnInit(): void {
		this._breakpointObserver
			.observe(['(max-width: 480px)'])
			.subscribe((state: BreakpointState) => {
				this.media = state.matches ? "mobile" : "desktop";
			});
	}

	accept() {
		this._userInfoService.acceptCookiePolicy();
		this.clicked = true;
		console.log(this.show);
		console.log(this.force && !this.clicked);
	}

	reject() {
		this._userInfoService.rejectCookiePolicy();
		this.clicked = true;
	}
}
